// Design tokens re-exported as CSS variable references.
// The single source of truth for color VALUES is src/app.css (:root / .dark custom
// properties) — this module only points at those, so it resolves correctly in both
// themes automatically and can never drift from CSS.
export const colors = {
  background: 'var(--background)',
  foreground: 'var(--foreground)',
  card: 'var(--card)',
  cardForeground: 'var(--card-foreground)',
  popover: 'var(--popover)',
  popoverForeground: 'var(--popover-foreground)',

  primary: 'var(--primary)',
  primaryForeground: 'var(--primary-foreground)',
  secondary: 'var(--secondary)',
  secondaryForeground: 'var(--secondary-foreground)',
  muted: 'var(--muted)',
  mutedForeground: 'var(--muted-foreground)',
  accent: 'var(--accent)',
  accentForeground: 'var(--accent-foreground)',
  destructive: 'var(--destructive)',
  border: 'var(--border)',
  input: 'var(--input)',
  ring: 'var(--ring)',
  ringLight: 'var(--ring-light)',
  danger: 'var(--danger)',
  warning: 'var(--warning)',

  chart1: 'var(--chart-1)',
  chart2: 'var(--chart-2)',
  chart3: 'var(--chart-3)',
  chart4: 'var(--chart-4)',
  chart5: 'var(--chart-5)',

  sidebar: 'var(--sidebar)',
  sidebarForeground: 'var(--sidebar-foreground)',
  sidebarPrimary: 'var(--sidebar-primary)',
  sidebarPrimaryForeground: 'var(--sidebar-primary-foreground)',
  sidebarAccent: 'var(--sidebar-accent)',
  sidebarAccentForeground: 'var(--sidebar-accent-foreground)',
  sidebarBorder: 'var(--sidebar-border)',
  sidebarRing: 'var(--sidebar-ring)',

  gray50: 'var(--color-gray-50)',
  gray100: 'var(--color-gray-100)',
  gray200: 'var(--color-gray-200)',
  gray300: 'var(--color-gray-300)',
  gray400: 'var(--color-gray-400)',
  gray500: 'var(--color-gray-500)',
  gray600: 'var(--color-gray-600)',
  gray700: 'var(--color-gray-700)',
  gray800: 'var(--color-gray-800)',
  gray900: 'var(--color-gray-900)',
  gray950: 'var(--color-gray-950)',

  success: 'var(--success)',
  successForeground: 'var(--success-foreground)',
  midnightBlue: 'var(--midnight-blue)',
  slateGrey: 'var(--slate-grey)',

  vantisMidnightblue: 'var(--vantis-midnightblue)',
  vantisViolet: 'var(--vantis-violet)',
  vantisVioletMuted: 'var(--vantis-violet-muted)',
  vantisPastelblue: 'var(--vantis-pastelblue)',
  vantisOffwhite: 'var(--vantis-offwhite)',
  vantisSilver: 'var(--vantis-silver)',
  vantisAquamarine: 'var(--vantis-aquamarine)',
  vantisPink: 'var(--vantis-pink)',
  vantisRed: 'var(--vantis-red)',
  vantisOrange: 'var(--vantis-orange)',
} as const;

export default colors;
